import {IconCircleCheck} from "@tabler/icons-react";
import PropTypes from "prop-types";
import {useTranslation} from "react-i18next";
import {PrimaryButton} from "@/components/Button";
import styles from "./WithdrawalResult.module.css";

const WithdrawalSuccess = ({amount, onClose}) => {
  const {t} = useTranslation();

  return (
    <div className={styles.resultContainer}>
      <div className={styles.iconWrapper}>
        <IconCircleCheck
          size={68}
          color="var(--accent-success)"
          fill="var(--accent-success)"
          stroke="var(--bg-main)"
        />
      </div>

      <h2 className={styles.resultTitle}>{t("withdrawalSuccessTitle")}</h2>

      <p className={styles.resultMessage}>{t("withdrawalSuccessMessage")}</p>

      <div className={styles.amountBadge}>
        <span className={styles.amountValue}>
          {new Intl.NumberFormat("es-VE", {
            style: "currency",
            currency: "VES",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(amount)}
        </span>
      </div>

      <div className={styles.buttonRow}>
        <PrimaryButton
          size="lg"
          onClick={onClose}
        >
          {t("withdrawalSuccessClose")}
        </PrimaryButton>
      </div>
    </div>
  );
};

WithdrawalSuccess.propTypes = {
  amount: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default WithdrawalSuccess;
